import $ from 'jquery';
import { View } from 'backbone';
import Template from 'report/properties/main/operator.ejs';
import util from 'util/Util.js';
import eventBus from 'EventBus.js';

class MainOperatorView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change #operator' :'updateField'
        };

        this.listenTo( eventBus, 'updateOperator'+ this.model.get('id'), this.render );
        this.listenTo(this.model, 'change', this.render);
        return this;
    }

    updateField(ev){
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal = ev.currentTarget.value;
        this.model.set( propName, propVal );
    }

    populateOperators() {
        const elOperator = $('#operator');
        if (elOperator) {
            elOperator.empty();
            elOperator[0].options[elOperator[0].options.length] = new Option('Equal', 'equal');
            elOperator[0].options[elOperator[0].options.length] = new Option('Wildcard', 'like');
            elOperator[0].options[elOperator[0].options.length] = new Option('Less', 'lessThan');
            elOperator[0].options[elOperator[0].options.length] = new Option('Less or Equal', 'lessOrEqual');
            elOperator[0].options[elOperator[0].options.length] = new Option('Greater', 'greaterThan');
            elOperator[0].options[elOperator[0].options.length] = new Option('Greater or Equal', 'greaterOrEqual');
            elOperator[0].options[elOperator[0].options.length] = new Option('Not Equal', 'notEqual');
        }
    }


    render() {

        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }
        if ( !util.isEmpty(this.model.get('dataSourceId')) &&  this.model.get('dataSourceId') !== 'none') {
            this.populateOperators();
        }

        $("#operator option[value='" + this.model.get('operator') + "']").prop('selected', true);


        this.delegateEvents();
        return this;
    }

}

export default MainOperatorView;
